import { Checkbox } from '@mui/material'
import { PARTNER_RESOURCE_MAP } from '@returnmates/client-core/src/constants/partner'
import Input from '@returnmates/ui-core/src/components/Input'
import { memo } from 'react'
import { Field } from 'react-final-form'

import CalendarIcon from '../../images/icons/calendar'
import Select from '../../Select'
import SingleDatePicker from '../../SingleDatePicker'
import useStyles from '../styles'

interface OtherSettingsProps {
  isCreateMode?: boolean
}

function OtherSettings({ isCreateMode }: OtherSettingsProps) {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Webhook URL:</p>
        <Field name="webhookUrl">
          {({ input, meta }) => {
            return (
              <Input
                placeholder="Webhook url"
                classes={{
                  textField: classes.input,
                }}
                onChange={input.onChange}
                value={input.value}
                fullWidth
                helperText={meta.error}
                error={meta.touched && meta.error}
                type="string"
              />
            )
          }}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Webhook Token:</p>
        <Field name="webhookToken">
          {({ input, meta }) => {
            return (
              <Input
                placeholder="Webhook token"
                classes={{
                  textField: classes.input,
                }}
                onChange={input.onChange}
                value={input.value}
                fullWidth
                helperText={meta.error}
                error={meta.touched && meta.error}
                type="string"
              />
            )
          }}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Scheduler limit</p>
        <Field name="schedulerLimit">
          {({ input, meta }) => (
            <Input
              placeholder="12"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
              type="number"
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Loading title</p>
        <Field name="loadingTitle">
          {({ input, meta }) => (
            <Input
              placeholder="Almost "
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Offer expire Date</p>
        <Field name="offerExpiresOn">
          {({ input, meta }) => (
            <SingleDatePicker
              placeholder="Select date"
              fullWidth
              value={input.value}
              momentFormat="YYYY-MM-DD"
              onChange={input.onChange}
              keyboardIcon={CalendarIcon}
              className={classes.datePicker}
              error={meta.touched && meta.error}
              helperText={meta.error}
              disablePast
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Label url</p>
        <Field name="labelUrl">
          {({ input, meta }) => (
            <Input
              placeholder="label url"
              classes={{
                textField: classes.input,
                input: classes.multilineInput,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Order resource:</p>
        <Field name="orderResource">
          {({ input }) => (
            <Select
              value={input.value}
              onChange={input.onChange}
              values={PARTNER_RESOURCE_MAP}
              placeholder="Choose resource"
              fullWidth
              className={classes.select}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>First pickup free</p>
        <Field name="isFirstPickupFree">
          {({ input }) => <Checkbox checked={input.value} onChange={input.onChange} />}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Package Description</p>
        <Field name="packageDescription">
          {({ input, meta }) => (
            <Input
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Package Editable</p>
        <Field name="isPkgEditingEnabled">
          {({ input }) => <Checkbox checked={input.value} onChange={input.onChange} />}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Order-based Pickup</p>
        <Field name="isOrderBasedPickup">
          {({ input }) => <Checkbox checked={input.value} onChange={input.onChange} />}
        </Field>
      </div>
      {!isCreateMode ? (
        <div className={classes.detailsRow}>
          <p className={classes.inputHead}>Audit Enabled</p>
          <Field name="isAuditEnabled">
            {({ input }) => <Checkbox checked={input.value} onChange={input.onChange} />}
          </Field>
        </div>
      ) : null}
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Order expire in # days</p>
        <Field name="orderExpire">
          {({ input, meta }) => (
            <Input
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
              placeholder="Set 0 if shouldn't expire"
              type="number"
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Receipt Tracking Required</p>
        <Field name="requiresReceiptTracking">
          {({ input }) => <Checkbox checked={input.value} onChange={input.onChange} />}
        </Field>
      </div>
    </>
  )
}

export default memo(OtherSettings)
